import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const PageContent = styled.div`
  padding-top: ${(props) =>
    props.$minimize
      ? props.theme.headerMinSize
      : props.theme.headerMaxSize};
  transition: padding-top ease-in 0.3s;
  animation: ${fadeIn} 0.3s ease-in;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    padding-right: 1rem;
    padding-left: 1rem;
  }
`;

export const LayoutColumns = styled.div`
  display: grid;
  grid-template-columns: 30% 70%;
  align-items: start;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    display: flex;
    flex-direction: column;
  }
`;

export const SideImage = styled.img`
  width: 100%;
  height: calc(
    100vh -
      ${(props) =>
        props.$minimize
          ? props.theme.headerMinSize
          : props.theme.headerMaxSize}
  );
  position: sticky;
  top: ${(props) =>
    props.$minimize
      ? props.theme.headerMinSize
      : props.theme.headerMaxSize};
  object-fit: cover;
  object-position: 0 5%;
  transition:
    top ease-in 0.3s,
    height ease-in 0.3s;

  @media only screen and (max-width: ${(props) => props.theme.breakpointMd}) {
    display: none;
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
`;
